module.exports = __webpack_public_path__ + "img/cashback-none.e6f03817.svg";